import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { CategoryCircles } from '../components/home/CategoryCircles';
import { EditorialSplit } from '../components/home/EditorialSplit';
import { RitualSetFeature } from '../components/home/RitualSetFeature';
import { CultureStory } from '../components/home/CultureStory';
import { LivingTeaser } from '../components/home/LivingTeaser';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ProductSection } from '../components/shop/ProductSection';
import { collections } from '../data/collections';
import { site } from '../data/site';
import { productsForCollection } from '../utils/products';
import { organizationJsonLd } from '../utils/seo';
import { useSeo } from '../hooks/useSeo';
export function Home() {
  useSeo({
    title: site.defaultTitle,
    description: site.defaultDescription,
    path: '/',
    jsonLd: organizationJsonLd()
  });
  const bestsellers = collections.find(c => c.slug === 'bestsellers');
  const top = bestsellers ? productsForCollection(bestsellers).filter(p => p.category !== 'sets').slice(0, 4) : [];
  return <>
      <HomeHero data-id="element-660" data-mp="2vyq6txqmm254" />
      <CategoryCircles data-id="element-661" data-mp="2vy82sexq2jmn" />
      <ProductSection title="Bestsellers" subtitle="Waar onze klanten steeds weer voor terugkomen." link={{
      to: '/collectie/bestsellers',
      label: 'Bekijk alles'
    }} products={top} data-id="element-662" data-mp="2vvltoav6nw2b" />
      <EditorialSplit data-id="element-663" data-mp="2hxxb59ol910f" />
      <RitualSetFeature data-id="element-664" data-mp="2hy72b0ldde7p" />
      <CultureStory data-id="element-665" data-mp="2hyp40cqswkn0" />
      <LivingTeaser data-id="element-666" data-mp="2i00a4j7py4ha" />
      <ReviewsSection data-id="element-667" data-mp="2d777c0vt967u" />
    </>;
}